import { MapboxLayerService } from '@/modules/ta/legacy/widget/services/types/MapboxLayerService';
import { CONGRESSIONAL_DISTRICT } from '@/modules/ta/legacy/widget/mapbox.constants';

export class MapboxCongressionalDistrictLayerService extends MapboxLayerService {
  constructor(widget) {
    super(widget, CONGRESSIONAL_DISTRICT);
  }

  getData(data = []) {
    return data
      .filter((row) => row.geocode1 && this.USCountryFilter(row))
      .map((row) => {
        const cd = row[this.groupedColumn.field] ?? '';
        return {
          name: cd,
          value: parseInt(String(row[this.column.field]).replace(/,/g, ''), 10),
        };
      });
  }
}
